import { MarkdownPlayground } from "../MarkdownPlayground";
import { TextUtilitiesPlayground } from "../TextUtilitiesPlayground";
import { ValueFormattingPlayground } from "../ValueFormattingPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const textFormattingEntries: PlaygroundComponentEntry[] = [
    {
        id: "value-formatting",
        label: "Value formatting",
        description: "Amount, bank number, and relative time display.",
        group: "components",
        render: () => <ValueFormattingPlayground />,
    },
    {
        id: "text-utilities",
        label: "Text utilities",
        description:
            "Text wrapping, truncation, copy, and disabled-with-tooltip helpers.",
        group: "components",
        render: () => <TextUtilitiesPlayground />,
    },
    {
        id: "markdown",
        label: "Markdown",
        description: "Markdown renderer.",
        group: "components",
        render: () => <MarkdownPlayground />,
    },
];
